function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.361 13.307L.901 7l9.46-6.307.446.668-7.834 5.223L2.349 7l.624.416 7.834 5.223-.446.668z",
  fill: "#0D5A91",
  stroke: "#939598"
});

var SvgBespokenLessThanDisabled = function SvgBespokenLessThanDisabled(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgBespokenLessThanDisabled;